import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatRelativeTime(timestamp: string | Date): string {
  const date =
    timestamp instanceof Date ? timestamp : new Date(timestamp + "Z");
  const now = new Date();

  // Format time as HH:MM
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const timeFormatted = `${hours}:${minutes}`;

  // Reset hours, minutes, seconds and milliseconds to compare just the dates
  const dateOnly = new Date(date);
  dateOnly.setHours(0, 0, 0, 0);

  const nowOnly = new Date(now);
  nowOnly.setHours(0, 0, 0, 0);

  // Calculate the difference in days
  const diffTime = dateOnly.getTime() - nowOnly.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  // Format relative date
  if (diffDays === 0) {
    return `today, ${timeFormatted}`;
  } else if (diffDays === -1) {
    return `yesterday, ${timeFormatted}`;
  } else if (diffDays < 0 && diffDays > -7) {
    return `${Math.abs(diffDays)} days ago, ${timeFormatted}`;
  } else {
    // For older dates, return the full date with time
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("default", {month: "long"});
    const year = date.getFullYear();
    return `${month} ${day}, ${year}, ${timeFormatted}`;
  }
}